export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";